import { defineMessages } from "react-intl";
import i18n from "app/i18n";

export default defineMessages({
  status: { id: "app.title.status", defaultMessage: i18n.t("Status") },
  status_plan: { id: "app.title.plan", defaultMessage: i18n.t("Plan") },
  status_plan_name: {
    id: "app.subscription.plan-monthly",
    defaultMessage: i18n.t("CoachNow+ Monthly"),
  },
  status_active_message: {
    id: "subscription.active-member-status",
    defaultMessage: i18n.t("You're a {planName} Member"),
  },

  cant_upgrade: {
    id: "subscription.cant-upgrade",
    defaultMessage: i18n.t("Please contact support to upgrade to CoachNow PRO"),
  },
  contact_support: {
    id: "subscription.contact-support",
    defaultMessage: i18n.t("Contact Support"),
  },

  upgrade_to_pro_title: {
    id: "subscription.status.upgrade_to_pro_title",
    defaultMessage: i18n.t("Upgrade to CoachNow PRO"),
  },
  upgrade_to_pro_subtitle: {
    id: "subscription.status.upgrade_to_pro_subtitle",
    defaultMessage: i18n.t(
      'CoachNow Pro unlocks all of our powerful features. For more information on the PRO feature set, <a href="https://coachnow.io/pro">click here</a>.',
    ),
  },
  switch_plan_title: {
    id: "subscription.status.switch_plan_title",
    defaultMessage: i18n.t("Switch to {planName}"),
  },
  upgrade_to_plus_title: {
    id: "subscription.status.upgrade_to_plus_title",
    defaultMessage: i18n.t("Upgrade to CoachNow+"),
  },
  upgrade_to_plus_subtitle: {
    id: "subscription.status.upgrade_to_plus_subtitle",
    defaultMessage: i18n.t(
      'CoachNow+ unlocks all of our powerful features. For more information on the CoachNow+ feature set, <a href="https://coachnow.com/plus">click here</a>.',
    ),
  },

  normal_price: {
    id: "subscription.status.normal_price",
    defaultMessage: i18n.t("Normal price"),
  },
  your_discount: {
    id: "subscription.status.your_discount",
    defaultMessage: i18n.t("Your discount"),
  },
  your_price: {
    id: "subscription.status.your_price",
    defaultMessage: i18n.t("Your price"),
  },
  your_first_payment: {
    id: "subscription.status.your_first_payment",
    defaultMessage: i18n.t("Your first payment"),
  },
  your_price_for_months: {
    id: "subscription.status.your_price_for_months",
    defaultMessage: i18n.t("Your price for the first {months} months"),
  },
  then_normal_price: {
    id: "subscription.status.then_normal_price",
    defaultMessage: i18n.t("then {price} / {period}"),
  },
  coupon_not_allowed: {
    id: "subscription.status.coupon_not_allowed",
    defaultMessage: i18n.t("Discount can not be applied to the selected plan."),
  },

  promo_code_label: {
    id: "subscription.status.promo_code_label",
    defaultMessage: i18n.t("Promo code"),
  },
  promo_code_apply: {
    id: "subscription.status.promo_code_apply",
    defaultMessage: i18n.t("Apply"),
  },

  upgrade_button: {
    id: "subscription.status.upgrade_button",
    defaultMessage: i18n.t("Upgrade Now"),
  },
  back_button: {
    id: "subscription.status.back_button",
    defaultMessage: i18n.t("Go to Dashboard"),
  },
});
